<ng-template cdkPortal #actions="cdkPortal">
  <button class="btn btn-icon btn-secondary" (click)="exportUsers()">
    <icon-users></icon-users>
    <span class="ml-2">Export users</span>
  </button>
</ng-template>
<smart-table [headers]="headers"
             [source]="source"
             (filtersChange)="onSearch($event)"
             (sortChange)="onSort($event)"
             [navigate]="entityPath">
  <ng-template smartTableColumn="id" let-item>
    <td>
      <span class="font-weight-medium">{{ item.id }}</span> <br>
    </td>
  </ng-template>

  <ng-template smartTableColumn="account" let-item>
    <td>
      <entity-link type="account"
                   [item]="item.account"
                   [name]="item.account?.email"
                   [strong]="true"
                   [showInfo]="false"
                   [relativePath]="relativePath">
      </entity-link>
    </td>
  </ng-template>
<!--  exportCsv-->

  <ng-template smartTableColumn="device" let-item>
    <td>
      <div *ngFor="let device of item.devices">
        {{ device?.idfa || device?.vendorId || device?.androidId }} <br>
        <small class="text-muted">{{ device?.id }}</small>
      </div>
    </td>
  </ng-template>

  <ng-template smartTableColumn="store" let-item>
    <td>
      <entity-link type="store" [item]="item.store" [relativePath]="relativePath"></entity-link>
    </td>
  </ng-template>

  <ng-template smartTableColumn="createdAt" let-item>
    <td>
      {{ item.createdAt | moment }}
    </td>
  </ng-template>

  <ng-template smartTableColumn="info" let-item>
    <td>
      {{ item.info }}
    </td>
  </ng-template>

  <ng-template smartTableColumn="coins" let-item>
    <td>
      <a [routerLink]="['/users', 'view', item.id, 'coin-flow']">Show dynamics</a>
    </td>
  </ng-template>

  <ng-template smartTableColumn="authAt" let-item>
    <td>
      {{ item.authAt | moment }}
    </td>
  </ng-template>

<!--  <ng-template smartTableColumn="actions" let-item>-->
<!--    <td class="text-right text-nowrap">-->
<!--      <button class="btn btn-danger btn-square btn-icon" (click)="delete(item.id, 'user', item.id)">-->
<!--        <icon-trash></icon-trash>-->
<!--      </button>-->
<!--    </td>-->
<!--  </ng-template>-->
</smart-table>

<pagination [itemsOnPage]="pagination.limit"
            [page]="pagination.currentPage"
            (pageChanged)="setPage($event)"
            [itemsFull]="pagination.fullCount"></pagination>

<preloader [hidden]="!loaderService.isLoading"></preloader>


